import baseAPI from '@/api/base';
import {
  EditRoom,
  GetRoom,
  RegisterRoom,
} from '@/dtos/room.dto';
import {
  DELETE_ROOM_URL,
  EDIT_ROOM_URL,
  GET_ROOM_URL,
  REGISTER_ROOM_URL,
  TOGGLE_ROOM_IS_ACTIVE_URL,
} from '@/utils/urls';
import { AxiosResponse } from 'axios';

class Room {
  static getRooms = async (
    getRoom: GetRoom
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.get(GET_ROOM_URL, {
      params: getRoom,
    });
    console.log('response', response);
    return response;
  };

  static registerRoom = async (
    registerRoom: RegisterRoom
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.post(
      REGISTER_ROOM_URL,
      {
        ...registerRoom,
      }
    );
    console.log('response', response);
    return response;
  };

  static editRoom = async (
    editRoom: EditRoom
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.put(
      EDIT_ROOM_URL,
      {
        ...editRoom,
      }
    );
    return response;
  };

  static toggleRoomIsActive = async (
    editRoom: EditRoom
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.patch(
      TOGGLE_ROOM_IS_ACTIVE_URL,
      {
        ...editRoom,
      }
    );
    return response;
  };

  static deleteRoom = async (
    id: string
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.delete(
      `${DELETE_ROOM_URL}/${id}`
    );
    return response;
  };
}

export default Room;
